import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Equipment } from '../Models/Equipment';
import { EquipmentTypeEnums } from '../Models/EquipmentTypeEnums';
import { EquipmentFeature } from '../Models/EquipmentFeature';
import { File } from '../Models/File';
import { SubCategoryManual } from '../Models/SubCategoryManual';
import { SelectOption } from '../Models/SelectOption';
import { EquipmentVideo } from '../Models/EquipmentVideo';

class EquipmentApi {
  static getEquipment(id: string) {
    return axios.get<Equipment>(`${API_URL}/api/equipment/${id}`);
  }
  static getEquipmentDisplay(id: string) {
    return axios.get<Equipment>(`${API_URL}/api/equipment/${id}/display`);
  }
  static SendEquipmentAvailabilityRequest(
    subject: string,
    message: string,
    userId: number,
    equipmentId: number
  ) {
    const request = JSON.stringify({
      subject,
      message,
      userId: userId,
      equipmentId: equipmentId,
    });
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('PriceBrosToken')}`,
      },
    };
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/sendEquipmentAvailabilityRequest`,
      request,
      config
    );
  }
  static addUpdateEquipment(request: Equipment) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment`,
      request,
      getAuthHeader()
    );
  }
  static deleteEquipment(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/equipment/${id}`,
      getAuthHeader()
    );
  }
  static getEquipmentList(
    manufactururId: number,
    equipmentType: EquipmentTypeEnums
  ) {
    return axios.get<Equipment[]>(
      `${API_URL}/api/equipment/list/${manufactururId}/${equipmentType}`,
      getAuthHeader()
    );
  }
  static uploadEquipmentImage(request: FormData, addWatermark: boolean) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/imageupload/` + addWatermark,
      request,
      getAuthHeader()
    );
  }
  static updateFromRimss(request: Equipment) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/updatefromrimss`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateEquipmentFeature(request: EquipmentFeature) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/feature`,
      request,
      getAuthHeader()
    );
  }
  static getEquipmentFeatureList(equipmentId: number) {
    return axios.get<EquipmentFeature[]>(
      `${API_URL}/api/equipment/feature/list/${equipmentId}`,
      getAuthHeader()
    );
  }
  static getEquipmentImageList(equipmentId: number) {
    return axios.get<File[]>(
      `${API_URL}/api/equipment/image/list/${equipmentId}`,
      getAuthHeader()
    );
  }
  static getEquipmentVideoList(equipmentId: number) {
    return axios.get<EquipmentVideo[]>(
      `${API_URL}/api/equipment/video/list/${equipmentId}`,
      getAuthHeader()
    );
  }
  static getEquipmentVideo(equipmentVideoId: number) {
    return axios.get<EquipmentVideo>(
      `${API_URL}/api/equipment/video/${equipmentVideoId}`,
      getAuthHeader()
    );
  }
  static addUpdateEquipmentVideo(request: EquipmentVideo) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/video`,
      request,
      getAuthHeader()
    );
  }
  static deleteEquipmentVideo(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/equipment/video/${id}`,
      getAuthHeader()
    );
  }
  static getEquipmentFeature(equipmentFeatureId: number) {
    return axios.get<EquipmentFeature>(
      `${API_URL}/api/equipment/feature/${equipmentFeatureId}`,
      getAuthHeader()
    );
  }
  static deleteEquipmentFeature(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/equipment/feature/${id}`,
      getAuthHeader()
    );
  }
  static uploadEquipmentFeatureImage(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/feature/imageupload`,
      request,
      getAuthHeader()
    );
  }
  static getEquipmentFiles(equipmentId: number) {
    return axios.get<File[]>(
      `${API_URL}/api/equipment/files/${equipmentId}`,
      getAuthHeader()
    );
  }
  static getSubCategoryManualList() {
    return axios.get<SubCategoryManual[]>(
      `${API_URL}/api/equipment/manual/list`,
      getAuthHeader()
    );
  }
  static addUpdateSubCategoryManual(request: SubCategoryManual) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/manual`,
      request,
      getAuthHeader()
    );
  }
  static deleteSubCategoryManual(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/equipment/manual/${id}`,
      getAuthHeader()
    );
  }
  static addFile(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/manual/addFile`,
      request,
      getAuthHeader()
    );
  }
  static updateEquipmentSubCategories(
    equipmentId: number,
    request: SelectOption[]
  ) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/equipment/${equipmentId}/subcategories/update`,
      request,
      getAuthHeader()
    );
  }
}

export default EquipmentApi;
